import React, { createContext, useState } from "react";

export const SignUpInfoContext = createContext(); 

export const SignUpInfoProvider = ({ children }) => {
    const [signUpInfo, setSignUpInfo] = useState({firstName:'', lastName:'', company:'', email:'', password:''}); 

  return (
    <SignUpInfoContext.Provider value={{ signUpInfo, setSignUpInfo }}>
      {children} 
    </SignUpInfoContext.Provider>
  );
};
